import i18n from '@/translation/i18n';

const menu = [
    {
        header: i18n.t('gift_giving_report.menu.part_1.header'),
        name: 'gift_giving_report',
        number: 1
    },
    { selector: 'packsAmount', name: i18n.t('gift_giving_report.menu.part_1.2') },
    { selector: 'giftGiverInfo', name: i18n.t('gift_giving_report.menu.part_1.3') },
    { selector: 'familyReaction', name: i18n.t('gift_giving_report.menu.part_1.4') },
    { selector: 'packsContent', name: i18n.t('gift_giving_report.menu.part_1.5') },
    { selector: 'workWithFamily', name: i18n.t('gift_giving_report.menu.part_1.6') },
    {
        header: i18n.t('gift_giving_report.menu.part_2.header'),
        name: 'gift_giving_report',
        number: 2
    },
    { header: i18n.t('gift_giving_report.menu.part_2.1'), name: 'gift_giving_report', number: 3 }
];

export default [menu];
